class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector(this.dataset.observe);
    if (!this.target) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('sticky-add-to-cart--visible', scrolledPast);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
